import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "./lib/cart";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import StoryPage from "./pages/StoryPage";
import CommissionsPage from "./pages/CommissionsPage";
import GiftsPage from "./pages/GiftsPage";
import ContactPage from "./pages/ContactPage";
import CarePage from "./pages/CarePage";
import PrivacyPage from "./pages/PrivacyPage";
import CartPage from "./pages/CartPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import SiteLayout from "./components/SiteLayout";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/shop/:slug" element={<ProductPage />} />
              <Route path="/story" element={<StoryPage />} />
              <Route path="/commissions" element={<CommissionsPage />} />
              <Route path="/gifts" element={<GiftsPage />} />
              <Route path="/care" element={<CarePage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
